import React, { useEffect, useRef, useState } from "react";
import { NewsFeed } from "../../assets/Images/ImagesLink";
import axios from "../../API/axios";
import SuccessToast from "../SuccessToast";
import WarningToast from "../WarningToast";
import ErrorToast from "../ErrorToast";
import ReactQuill from "react-quill";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import AddAPhotoSharpIcon from "@mui/icons-material/AddAPhotoSharp";
import PostComponent from "./PostComponent";
import moment from "moment";
import { Link } from "react-router-dom";
import SinglePostInteraction from "./SinglePostInteraction";

const PostUpdate = ({
  // showModal,
  openModal,
  closeModal,
  item,
  postList,
  PostOriginType,
  postOriginId,
  postId,
  setShowModal,
  setPostList,
  AllPostList,
}) => {
  const [postDataItem, setPostDataItem] = useState("");
  const profilPic = localStorage.getItem("profilPic");
  const [postContent, setPostContent] = useState("");
  const GetPostData = async () => {
    try {
      await axios
        .get(`/Posts/GetPostInfo?DeviceType=Web&PostId=${postId}`)
        .then((resData) => {
          console.log("postDataItem", resData);
          setPostContent(resData?.data?.responseData?.postInfo?.postInfo?.postContent);

          setPostDataItem(resData?.data?.responseData);
          setUserSelectedImage(resData?.data?.responseData?.postInfo?.postInfo?.mediaFilesList || []); // Initialize the state with the media files list
        });
    } catch (error) {
      console.log(error);
    }
  };

  console.log("postDataItem", postDataItem, AllPostList);

  useEffect(() => {
    GetPostData();
  }, []);

  const [removedImageIds, setRemovedImageIds] = useState([]); // To track removed image IDs
  const sessionId = localStorage.getItem("sessionId");
  const userUid = localStorage.getItem("userUid");
  const inputFileRef = useRef(null);
  let mediaFilesImage = postDataItem?.postInfo?.postInfo?.mediaFilesList;
  const [postData, setPostData] = useState("");
  const [privacyType, setPrivacyType] = useState(null);
  const [imageNames, setImageNames] = useState("");
  const [selectedImages, setSelectedImages] = useState([]);
  // const [PostContents, setPostContents] = useState(postDataItem);
  const [images, setImages] = useState([]);
  const [showPost, setShowPost] = useState(false);
  const [display, setDisplay] = useState(false);
  const [postID, setPostID] = useState("");

  console.log("PostContents", postContent);

  const [toastMessage, setToastMessage] = useState("");
  const [showToast, setShowToast] = useState(false);

  const [warningToastMessage, setWarningToastMessage] = useState("");
  const [showWarningToast, setShowWarningToast] = useState(false);

  const [ErrorToastMessage, setErrorToastMessage] = useState("");
  const [showErrorToast, setShowErrorToast] = useState(false);

  const [isloading, setIsloading] = useState(false);
  const guestModeData = localStorage.getItem("guestMode");

  const determinePostCategory = (postContent, newImages, existingImages) => {
    const containsVideo = (names) => {
      const videoExtensions = [
        ".mp4",
        ".webm",
        ".avi",
        ".mov",
        ".mkv",
        ".flv",
        ".wmv",
      ];
      return names.some((name) =>
        videoExtensions.includes(
          name?.slice(name.lastIndexOf(".")).toLowerCase()
        )
      );
    };

    const hasPostContent = postContent !== null && postContent.trim() !== "";
    const allImages = [...newImages, ...existingImages];
    const imageNames = allImages.map((image) => image.name || image.mediaName);

    const hasImages = imageNames.length > 0 && !containsVideo(imageNames);
    const hasVideos = imageNames.length > 0 && containsVideo(imageNames);

    if (
      (hasPostContent && hasImages) ||
      (hasPostContent && hasVideos) ||
      (hasImages && hasVideos)
    ) {
      return "UserStory";
    } else if (hasPostContent) {
      return "Text";
    } else if (hasImages) {
      return "Image";
    } else if (hasVideos) {
      return "Video";
    } else {
      return "UserStory";
    }
  };

  const handleSubmit = async () => {
    setIsloading(true);
    try {
      const formData = new FormData();
      formData.append("PostId", postId);
      formData.append("DeviceType", "Web");
      formData.append("sessionId", sessionId);
      formData.append(
        "PrivacyType",
        privacyType === null ? "Public" : privacyType
      );
      formData.append("PostOriginType", PostOriginType);
      const newImages = images.map((image) => image.name);
      const existingImages = userSelectedImage.map((image) => image.mediaName);
      const postCategory = determinePostCategory(
        postContent,
        newImages,
        existingImages
      );

      formData.append("PostCategory", postCategory);
      formData.append("PostContent", postContent || "");
      removedImageIds.forEach((id) => {
        formData.append("OldFilesToDelete", id);
      });
      images.forEach((file) => {
        formData.append(`FilesToUpload`, file.file);
      });

      formData.append("PostOriginID", postOriginId);

      const res = await axios.post("/Posts/UpdatePost", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setToastMessage(res.data.message);
      setShowToast(true);
      // GetPostData()
      setTimeout(() => {
        closeModal();
      }, 300);
      setPostContent("");
      AllPostList(1);
      const newPostId = postId;
      const postDetailsResponse = await axios.get(
        `/Posts/GetPostInfo?DeviceType=Web&PostId=${newPostId}`
      );
      const updatedPost = postDetailsResponse.data.responseData;
      console.log("updatedPost", updatedPost);
      setPostList((prev) =>
        prev.map((post) =>
          post.postId === updatedPost.postId ? updatedPost : post
        )
      );

      setIsloading(false);
    } catch (e) {
      console.log(e);
      if (e.response && e.response.status === 404) {
        setWarningToastMessage(e.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(e.response.data.message);
        setShowErrorToast(true);
      }
      setIsloading(false);
    }
  };

  const imageSelect = (event) => {
    console.log("image selected", event);
    const selectedFiles = event.target.files;
    console.log("selectedFiles", selectedFiles);
    const newImages = [];

    for (let i = 0; i < selectedFiles.length; i++) {
      const imageName = selectedFiles[i].name;
      if (!checkDuplicate(imageName)) {
        const imageUrl = URL.createObjectURL(selectedFiles[i]);
        newImages.push({
          name: imageName,
          url: imageUrl,
          file: selectedFiles[i],
        });
      } else {
        alert(`${imageName} is already added to the list`);
      }
    }

    setImages((prevImages) => [...prevImages, ...newImages]);
    event.target.value = null; // Reset file input
    console.log("image selected1", images);
  };

  const checkDuplicate = (name) => {
    return images.some((image) => image.name === name);
  };

  const [userSelectedImage, setUserSelectedImage] = useState({});
  console.log("image index", userSelectedImage);
  const userImages = (index) => {
    const removedImage = userSelectedImage[index];
    setRemovedImageIds((prevIds) => [...prevIds, removedImage.pstMid]); // Add removed image ID to the state
    setUserSelectedImage((prevImages) =>
      prevImages.filter((_, i) => i !== index)
    );
  };

  useEffect(() => {
    setUserSelectedImage(postDataItem?.postInfo?.postInfo?.mediaFilesList); // Initialize the state with the media files list
    console.log("useEffect is run");
  }, [postDataItem?.postInfo?.postInfo?.mediaFilesList]);

  console.log("userSelectedImage", userSelectedImage, images);

  const handleShowPost = () => {
    setShowPost(true);
  };

  const handleClosePost = () => {
    setShowPost(false);
  };
  const mediaFiles = postDataItem?.postInfo?.postInfo?.mediaFilesList?.map((item) => item?.pstMid);

  const handleImageChange = (event) => {
    const files = Array.from(event.target.files);
    const fileNames = files.map((file) => file.name);
    setImageNames(fileNames.join(", "));
    const imageUrls = files.map((file) => URL.createObjectURL(file));
    setSelectedImages((prevImages) => [...prevImages, ...imageUrls]);
  };

  const handleRemoveImage = (index) => {
    setSelectedImages((prevImages) => prevImages.filter((_, i) => i !== index));
    setImageNames((prevNames) => {
      const namesArray = prevNames.split(", ");
      namesArray.splice(index, 1);
      return namesArray.join(", ");
    });
  };

  const renderImages = () => {
    return images.map((image, index) => (
      <div
        key={index}
        className="image_container d-flex justify-content-center position-relative"
      >
        <img src={image.url} alt={image.name} />
        <span className="position-absolute" onClick={() => deleteImage(index)}>
          &times;
        </span>
      </div>
    ));
  };

  const deleteImage = (index) => {
    const updatedImages = [...images];
    updatedImages.splice(index, 1);
    setImages(updatedImages);
  };

  const Privacy = [
    { value: "Public", label: "Public" },
    { value: "Friends", label: "Friends" },
    { value: "OnlyMe", label: "OnlyMe" },
    { value: "Custom", label: "Custom" },
  ];

  const removeImage = (index) => {
    setImages((prevImages) => prevImages.filter((_, i) => i !== index));
  };

  const handlePaste = (e) => {
    const isCtrlV = e.ctrlKey && e.key === "v"; // Check if Ctrl+V was pressed

    if (isCtrlV) {
      e.preventDefault(); // Prevent the default paste action
      alert("Please use Ctrl + Shift + V to paste."); // Show alert
    }
  };

  //Handle Shared Post Update
  const [postContentMap, setPostContentMap] = useState({});
  const [sharedPostContent, setSharedPostContent] = useState("");

  const readMore = async (id) => {
    try {
      const res = await axios.get(
        `/Posts/GetPostMainContent/?DeviceType=Web&PostId=${id}`
      );
      setPostContentMap((prevMap) => ({
        ...prevMap,
        [id]: res.data.responseData,
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const addTargetBlankToAnchors = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;

    const anchors = div.querySelectorAll("a");
    anchors.forEach((anchor) => {
      anchor.setAttribute("target", "_blank");
      anchor.setAttribute("rel", "noopener noreferrer");
    });

    return div.innerHTML;
  };

  const linkifyContent = (htmlContent) => {
    const urlPattern =
      /(\b(https?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
    return htmlContent?.replace(urlPattern, function (url) {
      return `<a href="${url}" target="_blank" rel="noopener noreferrer">${url}</a>`;
    });
  };

  const replaceDynamicValues = (content, dynamicValues) => {
    if (!content || !dynamicValues) return content;

    dynamicValues.forEach((item) => {
      const placeholder = `{${item.dVno}}`;
      const replacement =
        item.type === "UserMention"
          ? `<a href="/user/${item.entityID}" class="user-mention">@${item.displayName}</a>`
          : item.type === "Hashtag"
            ? `<a href="/hashtag/${item.displayName}" class="hashtag">#${item.displayName}</a>`
            : item.displayName;

      content = content.replaceAll(placeholder, replacement);
    });

    return content;
  };

  useEffect(() => {
    const rawHtml = item?.postContent;
    const replaced = replaceDynamicValues(rawHtml, item?.dynamicValues);
    const withLinks = linkifyContent(replaced);
    const finalContent = addTargetBlankToAnchors(withLinks);
    setSharedPostContent(finalContent);
  }, [item]);

  const sharedPostFormattedContent = linkifyContent(
    addTargetBlankToAnchors(
      replaceDynamicValues(
        item?.sharedPost?.postContent,
        item?.sharedPost?.postContent?.dynamicValues
      )
    )
  );

  const editorRef = useRef(null);
  const [postInputValue, setPostInputValue] = useState("");
  const [postDynamicValues, setPostDynamicValues] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [mentionType, setMentionType] = useState("");
  const [SearchText, setSearchText] = useState("")
  const [query, setQuery] = useState("");
  const [typingTimeout, setTypingTimeout] = useState(null);
  const [cursorPosition, setCursorPosition] = useState(0);

  const handleChange = (content, delta, source, editor) => {
    const value = editor.getText(); // plain text, better than content HTML
    const caret = editor.getSelection()?.index || 0;

    setSharedPostContent(content); // still keep full HTML
    setCursorPosition(caret);
    detectTrigger(value, caret);

    // Filter out dynamic values no longer in content
    const updatedDynamicValues = postDynamicValues.filter(
      ({ type, display }) => {
        const prefix = type === "UserMention" ? "@" : "#";
        const fullMention = `${prefix}${display}`;
        return value.includes(fullMention);
      }
    );

    // Reassign dVno after filtering to keep {1}, {2}, ... in correct order
    const reassignedDynamicValues = updatedDynamicValues.map((item, index) => ({
      ...item,
      dVno: index + 1,
    }));

    setPostDynamicValues(reassignedDynamicValues);

    // Recompute postInputValue
    const quillInstance = editorRef.current?.getEditor?.();
    const htmlContent = quillInstance?.root?.innerHTML || "";

    const updatedPostInputValue = updatePostInputValueWithDynamicValues(
      htmlContent,
      reassignedDynamicValues
    );

    setPostInputValue(updatedPostInputValue);
  };

  const updatePostInputValueWithDynamicValues = (rawContent, dynamicValues) => {
    let modifiedText = rawContent;

    dynamicValues.forEach(({ type, dVno, display }) => {
      const prefix = type === "UserMention" ? "@" : "#";
      const fullMention = `${prefix}${display}`;
      const regex = new RegExp(escapeRegex(fullMention) + "(?!\\S)", "g");
      modifiedText = modifiedText.replace(regex, `{${dVno}}`);
    });

    return modifiedText.trim();
  };

  // Detect @ or #
  const detectTrigger = (value, caret) => {
    const textBeforeCursor = value.slice(0, caret);
    const match = textBeforeCursor.match(/([@#])(\w*)$/);
    if (match) {
      const trigger = match[1];
      const q = match[2];
      setMentionType(trigger === "@" ? "UserMention" : "Hashtag");
      setQuery(q);
      fetchSuggestions(q, trigger);
      setSearchText(q)
    } else {
      // setShowSuggestions(false);
      setSearchText('')
    }
  };

  const fetchSuggestions = async (searchText, triggerChar) => {
    const data = {
      deviceType: "Web",
      sessionId: sessionId,
    };

    try {
      if (triggerChar === "@") {
        const res = await axios.post(
          `General/MentionTagDDL?Search=${searchText}`,
          data
        );
        const results = res.data.responseData || [];
        setSuggestions(results);
        setShowSuggestions(results.length > 0);
      } else if (triggerChar === "#") {
        const res = await axios.post(
          `General/HashtagDDL?SearchHashtag=${searchText}`,
          data
        );
        const results = res.data.responseData || [];
        setSuggestions(results);
        setShowSuggestions(results.length > 0);
      }
    } catch (err) {
      console.error(err);
      if (triggerChar === "#" && searchText) {
        setShowSuggestions(true);
      } else {
        setShowSuggestions(false);
      }
    }
  };

  const insertMention = (suggestion, userUid) => {
    const quill = editorRef.current?.getEditor?.();
    if (!quill) return;

    const cursorPosition = quill.getSelection()?.index || 0;
    const textBeforeCursor = quill.getText(0, cursorPosition);
    const match = textBeforeCursor.match(/[@#]\w*$/);
    if (!match) return;

    const startIndex = cursorPosition - match[0].length;
    const mentionPrefix = mentionType === "UserMention" ? "@" : "#";
    const displayName = suggestion;
    const mentionText = `${mentionPrefix}${displayName} `;

    // Replace partial mention with full one
    quill.deleteText(startIndex, match[0].length);
    quill.insertText(startIndex, mentionText);
    quill.setSelection(startIndex + mentionText.length);

    // Update dynamic values
    const safePostDynamicValues = Array.isArray(postDynamicValues)
      ? postDynamicValues
      : [];
    const dVno = safePostDynamicValues.length + 1;

    const updatedPostDynamicValues = [
      ...safePostDynamicValues,
      {
        type: mentionType,
        dVno,
        entity: mentionType === "UserMention" ? userUid : suggestion,
        display: displayName,
      },
    ];
    setPostDynamicValues(updatedPostDynamicValues);

    const editorHtml = quill.root.innerHTML;
    const updatedInputValue = updatePostInputValueWithDynamicValues(
      editorHtml,
      updatedPostDynamicValues
    );
    setPostInputValue(updatedInputValue);
    setShowSuggestions(false);
    setSearchText('')
  };

  // Helper: Escape regex special characters
  const escapeRegex = (str) => {
    return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  };

  const updateSharedPost = async () => {
    setIsloading(true);
    try {
      setDisplay(true);
      const payload = {
        DeviceType: "Web",
        sessionId: sessionId,
        PrivacyType: privacyType || "Public",
        PostOriginType: "User",
        originPostId: postId,
        PostOriginID: userUid,
        PostCategory: "SharePost",
        PostContent: postInputValue ? postInputValue : sharedPostContent,
        DynamicValues: postDynamicValues,
      };
      const res = await axios.post("/Posts/UpdateShared-Post", payload, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      setToastMessage(res?.data?.message);
      setShowToast(true);
      closeModal();
      AllPostList();
      setPostDynamicValues([]);
      setPostInputValue("");
      const newPostId = res?.data?.responseData?.id;
      const postDetailsResponse = await axios.post(
        `/Posts/GetPostInfo?DeviceType=Web&PostId=${newPostId}`
      );
      const newPost = postDetailsResponse?.data?.responseData;
      setPostList((prev) => [newPost, ...prev]);
      setPostContent("");
      // setImages([])D;
      setPostID("");
      // setShowSecondModal(false);
      setIsloading(false);
      setPostDynamicValues([]);
      setPostInputValue("");
    } catch (error) {
      console.log("newPostId", error);
      if (error.response && error.response.status === 404) {
        setWarningToastMessage(error.response.data.message);
        setShowWarningToast(true);
      } else {
        setErrorToastMessage(error.response.data.message);
        setShowErrorToast(true);
      }
      setIsloading(false);
    }
  };
  return (
    <>
      {openModal &&
        (item?.sharedPost ? (
          <div
            className="modal fade show sharedPostModal"
            tabIndex="-1"
            role="dialog"
            style={{ display: "block" }}
          >
            {console.log("item88888888888", item)}
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content p-2">
                <div className="modalBorder d-flex justify-content-between align-items-center">
                  <h6>Shared Post View</h6>
                  <CloseSharpIcon
                    className="material-symbols-sharp me-2 pointer"
                    onClick={closeModal}
                  />
                </div>
                <div className="m-3">
                  <div
                    className="modal fade show postAdd"
                    tabIndex="-1"
                    role="dialog"
                    style={{ display: "block" }}
                  >
                    <div
                      className="modal-dialog modal-dialog-centered"
                      role="document"
                    >
                      <div className="modal-content p-2">
                        <div className="modalBorder d-flex justify-content-between align-items-center">
                          <h6>Update Shared Post</h6>
                          <CloseSharpIcon
                            className="material-symbols-sharp me-2 pointer"
                            onClick={closeModal}
                          />
                        </div>
                        {/* <div className="d-flex align-items-center m-3 pb-3 modalBorder ">
                <div className="ImgAvatar">
                  <img src={profilPic} alt="" width={50} style={{ borderRadius: '50%' }} />
                </div>
                <p className="f-16 AddPost ms-2">What's on your mind?</p>
              </div> */}
                        <div className="m-3">
                          {/* <textarea
                  autoFocus={true}
                  id="about"
                  placeholder="Update your post here"
                  name="about"
                  defaultValue={postDataItem?.postContent}
                  onChange={(e) => setPostContent(e.target.value)}
                  rows="4"
                  cols="65"
                ></textarea> */}
                          {/* <ReactQuill
                            value={postContent}
                            onChange={setPostContent}
                            onKeyDown={handlePaste}
                            placeholder="Update Post Here"
                            modules={{
                              toolbar: false,
                            }}
                            formats={[
                              "header",
                              "font",
                              "size",
                              "bold",
                              "italic",
                              "underline",
                              "strike",
                              "blockquote",
                              "list",
                              "bullet",
                              "indent",
                              "link",
                            ]}
                          /> */}

                          <div className="d-flex align-items-center mt-4">
                            <div className="ImgAvatar">
                              <img
                                src={item?.userAvatar}
                                alt=""
                                style={{ borderRadius: "50px" }}
                              />
                            </div>

                            <div className="ms-2">
                              <h4 className="f-14 fw-bold mb-0">
                                {item.userName}{" "}
                              </h4>
                              <p className="f-12">{item?.title}</p>
                              <p className="f-12">{item?.additionalInfo}</p>
                              <p className="f-10 label">
                                {moment
                                  .utc(item.creationTime)
                                  .local()
                                  .format("DD MMMM YYYY [at] h:mm a")}
                              </p>
                            </div>
                          </div>
                          <h2>{postContent}</h2>
                          <div>
                            {item?.postContent && (
                              <div className="f-14 p-2 postContent">
                                <ReactQuill
                                  value={sharedPostContent}
                                  ref={editorRef}
                                  onChange={(
                                    content,
                                    delta,
                                    source,
                                    editor
                                  ) => {
                                    handleChange(
                                      content,
                                      delta,
                                      source,
                                      editor
                                    );
                                  }}
                                  modules={{ toolbar: false }}
                                  placeholder="Update post here"
                                />

                                {showSuggestions && (
                                  <ul className="suggestion-box">
                                    {mentionType === "Hashtag" ? <li
                                      onMouseDown={(e) => {
                                        e.preventDefault(); // Prevent editor blur
                                        insertMention(
                                          SearchText,
                                          null
                                        );
                                      }}
                                      className="suggestion-item"
                                    >
                                      <span>{SearchText ? `#${SearchText}` : ''}</span>
                                    </li> : null}
                                    {suggestions?.map((item, index) => (
                                      <li
                                        key={index}
                                        onMouseDown={(e) => {
                                          e.preventDefault(); // Prevent editor blur
                                          insertMention(
                                            mentionType === "UserMention"
                                              ? item?.entityName
                                              : item?.hashTag,
                                            mentionType === "UserMention"
                                              ? item?.userUid
                                              : null
                                          );
                                        }}
                                        className="suggestion-item"
                                      >
                                        {mentionType === "UserMention" ? (
                                          <>
                                            <img
                                              src={item?.avatar}
                                              alt={item?.entityName}
                                              className="avatar"
                                            />
                                            <span>{item?.entityName}</span>
                                          </>
                                        ) : (
                                          <span>#{item?.hashTag}</span>
                                        )}
                                      </li>
                                    ))}
                                  </ul>
                                )}
                                {/* {!postContentMap[item?.postId] &&
                                  item?.readMore && (
                                    <a
                                      onClick={() => readMore(item?.postId)}
                                      className="pointer"
                                    >
                                      Read More
                                    </a>
                                  )} */}
                              </div>
                            )}
                            {item?.sharedPost ? (
                              <>
                                <div className="row w-94 m-0 singlePostLink">
                                  <div className="featured-card user-postOnlyContent">
                                    <div className="feature-content p-2 d-flex justify-content-between">
                                      {item?.sharedPost?.postOriginType ===
                                        "Company" ? (
                                        <Link
                                          to={`/Company/${item?.sharedPost?.userUid}`}
                                        >
                                          <div className="d-flex align-items-center">
                                            <div className="ImgAvatar">
                                              <img
                                                src={
                                                  item?.sharedPost?.userAvatar
                                                }
                                                alt=""
                                                style={{ borderRadius: "50px" }}
                                              />
                                            </div>
                                            <div className="ms-2">
                                              <h4 className="f-14 fw-bold mb-0">
                                                {item?.sharedPost?.userName}
                                              </h4>
                                              <p className="f-12">
                                                {/* {moment(item?.sharedPost.creationTime).format(
                                                        "MMMM Do YYYY, h:mm:ss a"
                                                      )} */}
                                                {moment
                                                  .utc(
                                                    item?.sharedPost
                                                      ?.creationTime
                                                  )
                                                  .local()
                                                  .format(
                                                    "DD MMMM YYYY [at] h:mm a"
                                                  )}
                                              </p>
                                            </div>
                                          </div>
                                        </Link>
                                      ) : (
                                        <Link
                                          to={`/User/${item?.sharedPost?.userUid}`}
                                        >
                                          <div className="d-flex align-items-center">
                                            <div className="ImgAvatar">
                                              <img
                                                src={
                                                  item?.sharedPost?.userAvatar
                                                }
                                                alt=""
                                                style={{ borderRadius: "50px" }}
                                              />
                                            </div>
                                            <div className="ms-2">
                                              <h4 className="f-14 fw-bold mb-0">
                                                {item?.sharedPost?.userName}
                                              </h4>
                                              <p className="f-12">
                                                {/* {moment(item?.sharedPost.creationTime).format(
                                                        "MMMM Do YYYY, h:mm:ss a"
                                                      )} */}
                                                {moment
                                                  .utc(
                                                    item?.sharedPost
                                                      ?.creationTime
                                                  )
                                                  .local()
                                                  .format(
                                                    "DD MMMM YYYY [at] h:mm a"
                                                  )}
                                              </p>
                                            </div>
                                          </div>
                                        </Link>
                                      )}

                                      {guestModeData === "true" ? null : (
                                        <div className="row">
                                          <div>
                                            <SinglePostInteraction
                                              postId={item?.sharedPost?.postId}
                                            // AllPostList={AllPostList}
                                            // ite.sharedPost={item?.sharedPost}
                                            // setitem?.sharedPost={setitem?.sharedPost}
                                            // isfollowed={isfollowed}
                                            // setIsfollowed={setIsfollowed}
                                            />
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                    {item?.sharedPost?.postContent && (
                                      <>
                                        <div className="f-14 p-2 postContent">
                                          <div
                                            dangerouslySetInnerHTML={{
                                              __html:
                                                sharedPostFormattedContent,
                                            }}
                                          />
                                        </div>
                                        <div
                                          className="feed-post"
                                          style={{
                                            paddingTop:
                                              item?.sharedPost
                                                ?.postMediaCount === 0
                                                ? "60px"
                                                : "4px",
                                          }}
                                        >
                                          <div className="row">
                                            {item?.sharedPost?.mediaFilesList
                                              .slice(0, 4)
                                              .map((file, idx) => (
                                                <div
                                                  key={idx}
                                                  className={`col-${item?.sharedPost
                                                    ?.mediaFilesList
                                                    .length === 1
                                                    ? "12"
                                                    : "6"
                                                    } ${item?.sharedPost
                                                      ?.mediaFilesList
                                                      .length === 3 && idx === 0
                                                      ? "col-12"
                                                      : ""
                                                    }`}
                                                  style={{
                                                    position: "relative",
                                                    padding:
                                                      item?.sharedPost
                                                        ?.mediaFilesList
                                                        .length === 1
                                                        ? "0"
                                                        : item?.sharedPost
                                                          ?.mediaFilesList
                                                          .length === 3 &&
                                                          idx === 0
                                                          ? "0 0 5px 0"
                                                          : item?.sharedPost
                                                            ?.mediaFilesList
                                                            .length === 3 &&
                                                            idx === 1
                                                            ? "0 5px 5px 0"
                                                            : item?.sharedPost
                                                              ?.mediaFilesList
                                                              .length === 4 &&
                                                              idx === 2
                                                              ? "0 5px 0 0"
                                                              : item?.sharedPost
                                                                ?.mediaFilesList
                                                                .length === 4 &&
                                                                idx === 0
                                                                ? "0 5px 5px 0"
                                                                : item?.sharedPost
                                                                  ?.mediaFilesList
                                                                  .length === 2 &&
                                                                  idx === 0
                                                                  ? "0 5px 5px 0"
                                                                  : "0",
                                                  }}
                                                >
                                                  <h2>{file.length}</h2>
                                                  <img
                                                    src={file.mediaName}
                                                    alt=""
                                                    className="img-fluid"
                                                    width={"100%"}
                                                  />
                                                  {idx === 3 &&
                                                    item?.sharedPost
                                                      ?.postMediaCount > 4 && (
                                                      <div className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-50 text-white">
                                                        +
                                                        {item?.sharedPost
                                                          ?.postMediaCount - 4}
                                                      </div>
                                                    )}
                                                </div>
                                              ))}
                                          </div>
                                        </div>
                                      </>
                                    )}
                                  </div>
                                </div>
                                {/* </div> */}
                              </>
                            ) : (
                              ""
                            )}
                          </div>

                          {/* Main post image */}
                          <div
                            className="feed-post"
                            style={{
                              paddingTop:
                                item?.postMediaCount === 0 ? "60px" : "4px",
                            }}
                          >
                            <div className="row">
                              {item.mediaFilesList
                                ?.slice(0, 4)
                                .map((file, idx) => (
                                  <div
                                    key={idx}
                                    className={`col-${item.mediaFilesList.length === 1
                                      ? "12"
                                      : "6"
                                      } ${item.mediaFilesList.length === 3 &&
                                        idx === 0
                                        ? "col-12"
                                        : ""
                                      }`}
                                    style={{
                                      position: "relative",
                                      padding:
                                        item.mediaFilesList.length === 3 &&
                                          idx === 0
                                          ? "0 0 5px 0"
                                          : item.mediaFilesList.length === 3 &&
                                            idx === 1
                                            ? "0 5px 5px 0"
                                            : item.mediaFilesList.length === 4 &&
                                              idx === 2
                                              ? "0 5px 0 0"
                                              : item.mediaFilesList.length === 4 &&
                                                idx === 0
                                                ? "0 5px 5px 0"
                                                : item.mediaFilesList.length === 2 &&
                                                  idx === 0
                                                  ? "0 5px 5px 0"
                                                  : "",
                                    }}
                                  >
                                    <img
                                      src={file.mediaName}
                                      alt=""
                                      className="img-fluid"
                                      width={"100%"}
                                    />
                                    {idx === 3 && item.postMediaCount > 4 && (
                                      <div className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-50 text-white">
                                        +{item.postMediaCount - 4}
                                      </div>
                                    )}
                                  </div>
                                ))}
                            </div>
                          </div>
                        </div>

                        <div className="m-3 mb-1 d-flex align-items-center">
                          <button
                            className="mainBtn ms-auto"
                            disabled={isloading}
                            onClick={updateSharedPost}
                          >
                            {isloading === true ? "Updating.." : "Update"}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div
            className="modal fade show postAdd"
            tabIndex="-1"
            role="dialog"
            style={{ display: "block" }}
          >
            {console.log("item88888888888", item)}

            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content p-2">
                <div className="modalBorder d-flex justify-content-between align-items-center">
                  <h6>Update Post</h6>
                  <CloseSharpIcon
                    className="material-symbols-sharp me-2 pointer"
                    onClick={closeModal}
                  />
                </div>
                {/* <div className="d-flex align-items-center m-3 pb-3 modalBorder ">
                <div className="ImgAvatar">
                  <img src={profilPic} alt="" width={50} style={{ borderRadius: '50%' }} />
                </div>
                <p className="f-16 AddPost ms-2">What's on your mind?</p>
              </div> */}
                <div className="m-3">
                  {/* <textarea
                  autoFocus={true}
                  id="about"
                  placeholder="Update your post here"
                  name="about"
                  defaultValue={postDataItem?.postContent}
                  onChange={(e) => setPostContent(e.target.value)}
                  rows="4"
                  cols="65"
                ></textarea> */}
                  <ReactQuill
                    value={postContent}
                    onChange={setPostContent}
                    onKeyDown={handlePaste}
                    placeholder="Update Post Here"
                    // defaultValue={postDataItem?.postInfo?.postInfo?.postContent}
                    // onChange={(e) => setPostContent(e.target.value)}

                    // modules={{
                    //   toolbar: [
                    //     [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
                    //     [{ size: [] }],
                    //     ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                    //     [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
                    //     ['link'],
                    //     ['clean']
                    //   ]
                    // }}
                    modules={{
                      toolbar: false,
                    }}
                    formats={[
                      "header",
                      "font",
                      "size",
                      "bold",
                      "italic",
                      "underline",
                      "strike",
                      "blockquote",
                      "list",
                      "bullet",
                      "indent",
                      "link",
                    ]}
                  />

                  {/* <div className="d-flex align-items-center mt-4">
                  <div className="ImgAvatar">
                    <img
                      src={item?.postInfo?.userAvatar}
                      alt=""
                      style={{ borderRadius: "50px" }}
                    />
                  </div>

                  <div className="ms-2">
                    <h4 className="f-14 fw-bold mb-0">{item?.postInfo?.userName} </h4>
                    <p className="f-12">{item?.postInfo?.title}</p>
                    <p className="f-12">{item?.postInfo?.additionalInfo}</p>
                    <p className="f-10 label">
                      {moment
                        .utc(item?.postInfo?.creationTime)
                        .local()
                        .format("DD MMMM YYYY [at] h:mm a")}
                    </p>
                  </div>
                </div> */}
                  {/* </Link> */}
                  {/* <PostComponent item={item} /> */}

                  {/* Main post image */}
                  <div
                    className="feed-post"
                    style={{
                      paddingTop: item?.postInfo?.postMediaCount === 0 ? "60px" : "4px",
                    }}
                  >
                    {console.log("item5555555555555", item)}

                    {/* <div className="row">
                      {item?.postInfo?.mediaFilesList?.slice(0, 4).map((file, idx) => (
                        <div
                          key={idx}
                          className={`col-${
                            item?.postInfo?.mediaFilesList.length === 1 ? "12" : "6"
                          } ${
                            item?.postInfo?.mediaFilesList.length === 3 && idx === 0
                              ? "col-12"
                              : ""
                          }`}
                          style={{
                            position: "relative",
                            padding:
                              item?.postInfo?.mediaFilesList.length === 3 && idx === 0
                                ? "0 0 5px 0"
                                : item?.postInfo?.mediaFilesList.length === 3 && idx === 1
                                ? "0 5px 5px 0"
                                : item?.postInfo?.mediaFilesList.length === 4 && idx === 2
                                ? "0 5px 0 0"
                                : item?.postInfo?.mediaFilesList.length === 4 && idx === 0
                                ? "0 5px 5px 0"
                                : item?.postInfo?.mediaFilesList.length === 2 && idx === 0
                                ? "0 5px 5px 0"
                                : "",
                          }}
                        >
                          <img
                            src={file.mediaName}
                            alt=""
                            className="img-fluid"
                            width={"100%"}
                          />
                          {idx === 3 && item?.postInfo?.postMediaCount > 4 && (
                            <div className="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center bg-dark bg-opacity-50 text-white">
                              +{item?.postInfo?.postMediaCount - 4}
                            </div>
                          )}
                        </div>
                      ))}
                    </div> */}
                  </div>
                </div>

                {/* Adding Extra Image */}
                <div className="modal-border d-flex justify-content-center align-items-center">
                  <input
                    id="fileInput"
                    type="file"
                    onChange={(event) => {
                      imageSelect(event);
                    }}
                    style={{ display: "none" }}
                    ref={inputFileRef}
                    multiple
                  />

                  {images.length > 0 && (
                    <div className="post-selected d-flex justify-content-center flex-wrap">
                      {images.map((image, index) => (
                        <div key={index} className="position-relative m-2">
                          <img
                            src={image.url}
                            alt={`Selected Image ${index}`}
                            style={{
                              maxWidth: "200px",
                              maxHeight: "300px",
                              objectFit: "cover",
                            }}
                          />
                          <button
                            onClick={() => removeImage(index)}
                            className="btn btn-danger position-absolute top-0 end-0"
                            style={{
                              transform: "translate(50%, -50%)",
                              borderRadius: "50%",
                              width: "24px",
                              height: "24px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              padding: "0",
                            }}
                          >
                            &times;
                          </button>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {userSelectedImage?.length > 0 && (
                  <div className="post-selected hhh d-flex justify-content-center flex-wrap">
                    {userSelectedImage?.map((imageUrl, index) => (
                      <div key={index} className="position-relative m-2">
                        <img
                          src={imageUrl.mediaName}
                          alt={`Selected Image ${index}`}
                          style={{
                            maxWidth: "200px",
                            maxHeight: "300px",
                            objectFit: "cover",
                          }}
                        />
                        <button
                          onClick={() => userImages(index)}
                          className="btn btn-danger position-absolute top-0 end-0"
                          style={{
                            transform: "translate(50%, -50%)",
                            borderRadius: "50%",
                            width: "24px",
                            height: "24px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            padding: "0",
                          }}
                        >
                          &times;
                        </button>
                      </div>
                    ))}
                  </div>
                )}

                <div className="m-3 mb-1 d-flex align-items-center">
                  <form className="form" action="#" method="post" id="form">
                    <input
                      type="file"
                      name="Image"
                      id="image"
                      multiple
                      className="d-none"
                      onChange={(event) => {
                        imageSelect(event);
                      }}
                      ref={inputFileRef}
                    />
                    <AddAPhotoSharpIcon
                      className="material-symbols-sharp me-2 mt-2 pointer"
                      onClick={() => inputFileRef.current.click()} // Trigger the file input click
                    />
                  </form>
                  <button
                    className="mainBtn ms-auto"
                    disabled={isloading}
                    onClick={handleSubmit}
                  >
                    {isloading === true ? "Updating.." : "Update"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}

      <SuccessToast
        show={showToast}
        message={toastMessage}
        onClose={() => setShowToast(false)}
      />

      <WarningToast
        show={showWarningToast}
        message={warningToastMessage}
        onClose={() => setShowWarningToast(false)}
      />

      <ErrorToast
        show={showErrorToast}
        message={ErrorToastMessage}
        onClose={() => setShowErrorToast(false)}
      />
    </>
  );
};

export default PostUpdate;
